import { createSelector } from "reselect";

const selectAllGroups = (state) => state.groups;

export const selectGroups = createSelector(
  [selectAllGroups],
  (group) => group.groups
);
export const selectNumGroups = createSelector(
  [selectAllGroups],
  (group) => group.numGroups
);
export const selectIsFetchingGroups = createSelector(
  [selectAllGroups],
  (group) => group.isFetchingGroups
);
export const selectSelectedGroups = createSelector(
  [selectAllGroups],
  (group) => group.selectedGroups
);
export const selectSearchGroupsQuery = createSelector(
  [selectAllGroups],
  (group) => group.searchGroupsQuery
);
export const selectGroupsOnPage = createSelector(
  [selectAllGroups],
  (group) => group.groupsOnPage
);
